import { FunctionComponent } from 'react';

import { UnderlineTag } from '@/atoms';
import ListStepByStep from '@/atoms/list-step-by-step';

import { TypeInfoListStepByStepProps } from './types';

/**
 * InfoListStepByStep
 */
export const InfoListStepByStep: FunctionComponent<
  TypeInfoListStepByStepProps
> = ({ className = '', listText, subtitle }: TypeInfoListStepByStepProps) => (
  <div className={className}>
    <UnderlineTag position="left" theme="light">
      {subtitle}
    </UnderlineTag>

    <div className="w-full flex justify-between mt-10">
      <div className="pr-5 divide-y divide-secondary-200">
        {listText.map((ele) => (
          <ListStepByStep
            key={ele.id}
            title={ele.title}
            text={ele.text}
            className="py-6"
          />
        ))}
      </div>
    </div>
  </div>
);

InfoListStepByStep.displayName = 'InfoListStepByStep';
